import { Record } from 'immutable';
export default class ExtensionInstance extends Record({
  actionTypeId: null,
  extensionDefinitionId: null,
  extensionDefinitionVersion: null,
  fields: [],
  objectRequestOptions: {
    properties: []
  }
}, 'ExtensionInstance') {
  setFields(fields) {
    return this.set('fields', fields);
  }
  setObjectRequestOptions(objectRequestOptions) {
    return this.set('objectRequestOptions', objectRequestOptions);
  }
}